import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();

  constructor(private ngZone: NgZone) {} // Inject NgZone

  show() {
    this.ngZone.run(() => {
      this.loadingSubject.next(true);
    });
  }

  hide() {
    this.ngZone.run(() => {
      this.loadingSubject.next(false);
    });
  }
}